import React, {Component} from "react";
//import PropTypes from "prop-types";

//import { withStyles } from "@material-ui/core/styles";
import withStyles from '@material-ui/core/styles/withStyles';
import Table from "@material-ui/core/Table/index";
import TableBody from "@material-ui/core/TableBody/index";
import TableCell from "@material-ui/core/TableCell/index";
import TableHead from "@material-ui/core/TableHead/index";
import TableRow from "@material-ui/core/TableRow/index";
import Paper from "@material-ui/core/Paper/index";
import 'typeface-roboto';
import {Typography} from "@material-ui/core";
import firebase from 'firebase';



function createLines(priority, Analytics, BusinessApps, CMS, Core, Search, Social) {
    return {priority, Analytics, BusinessApps, CMS, Core, Search, Social};
}

let _data = [
    createLines("P1",0,0,0,0,0,0),
    createLines("P2",0,0,0,0,0,0),
    createLines("P3",0,0,0,0,0,0),
    createLines("P4",0,0,0,0,0,0),
];

const DataStore = {
    listeners: [],

    get data() {
        return _data;
    },
    set data(val) {
        //console.log("authorization : Basic "+val);
        fetch('https://us-central1-lumdash.cloudfunctions.net/fetch',{
            //fetch('http://localhost:5000/lumdash/us-central1/fetch',{
            method: 'GET',
            mode: 'cors',
            headers: {
                'Access-Control-Allow-Origin':'*',
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':'Basic '+ val
            }
        })
            .then(response => {
                //console.log('Response : '+ response.status + ' ' + response.statusText +' ');
                if(response.ok) {
                    return response.json()
                }
                else{
                    return {
                        "P1PerPods": {'Analytics':0, 'BusinessApps':0, 'CMS':0, 'Core':0, 'Search':0, 'Social':0},
                        "P2PerPods": {'Analytics':0, 'BusinessApps':0, 'CMS':0, 'Core':0, 'Search':0, 'Social':0},
                        "P3PerPods": {'Analytics':0, 'BusinessApps':0, 'CMS':0, 'Core':0, 'Search':0, 'Social':0},
                        "P4PerPods": {'Analytics':0, 'BusinessApps':0, 'CMS':0, 'Core':0, 'Search':0, 'Social':0},

                    };
                }
            })
            .then(data => {
                _data = [
                    createLines("P1", data.P1PerPods.Analytics, data.P1PerPods.BusinessApps, data.P1PerPods.CMS, data.P1PerPods.Core, data.P1PerPods.Search, data.P1PerPods.Social),
                    createLines("P2", data.P2PerPods.Analytics, data.P2PerPods.BusinessApps, data.P2PerPods.CMS, data.P2PerPods.Core, data.P2PerPods.Search, data.P2PerPods.Social),
                    createLines("P3", data.P3PerPods.Analytics, data.P3PerPods.BusinessApps, data.P3PerPods.CMS, data.P3PerPods.Core, data.P3PerPods.Search, data.P3PerPods.Social),
                    createLines("P4", data.P4PerPods.Analytics, data.P4PerPods.BusinessApps, data.P4PerPods.CMS, data.P4PerPods.Core, data.P4PerPods.Search, data.P4PerPods.Social),
                    createLines("TOTAL",data.P1PerPods.Analytics+data.P2PerPods.Analytics+data.P3PerPods.Analytics+data.P4PerPods.Analytics,
                        data.P1PerPods.BusinessApps+data.P2PerPods.BusinessApps+data.P3PerPods.BusinessApps+data.P4PerPods.BusinessApps,
                        data.P1PerPods.CMS+data.P2PerPods.CMS+data.P3PerPods.CMS+data.P4PerPods.CMS,
                        data.P1PerPods.Core+data.P2PerPods.Core+data.P3PerPods.Core+data.P4PerPods.Core,
                        data.P1PerPods.Search+data.P2PerPods.Search+data.P3PerPods.Search+data.P4PerPods.Search,
                        data.P1PerPods.Social+data.P2PerPods.Social+data.P3PerPods.Social+data.P4PerPods.Social)
                ]
            })
            .then(()=>{
                this.notify();
            });

    },
    listen(handler) {
        this.listeners.push(handler);
    },
    remove(handler) {
        this.listeners = this.listeners.filter(x => x !== handler);
    },
    notify() {
        this.listeners.forEach(f => f());
    }
};

//First fetch
//DataStore.data = 0;

/*
############################################################################################
######################           Tableau : Style            ################################
############################################################################################
 */


const CustomTableCell = withStyles(theme => ({
    head: {
        //backgroundColor: theme.palette.background.paper,
        color: theme.palette.common.white,
        borderColor: theme.palette.background.paper,
        minHeight:"30px",
        minWidth:"30px",
        fontSize: 18


    },
    body: {
        fontSize: 20,
        minHeight:"30px",
        minWidth:"30px",
        color: theme.palette.common.white,
        borderColor: theme.palette.background.paper

    }
}))(TableCell);

const styles = theme => ({

    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
        marginTop: theme.spacing.unit * 3,
        overflowX: "auto",
        borderColor: theme.palette.background.paper

    },
    table: {
        minWidth: 300,
        minHeight: 450
    },

});


/*
############################################################################################
###################### Tableau : Tickets per Pods ##########################################
############################################################################################
 */


class CustomizedTable extends Component {

    constructor(props){
        super(props);
        this.state = {
            data: DataStore.data
        }
        //First Fetch
        // DataStore.data = this.props.anUser;
        firebase.auth().currentUser.getIdToken(true).then(function(idToken){
            //console.log(idToken);
            DataStore.data = idToken;
        });
    }

    update = () => {
        this.setState({data: DataStore.data});
    }

    componentDidMount(){
        setInterval(function(){
            firebase.auth().currentUser.getIdToken(true).then(function(idToken){
                //console.log(idToken);
                DataStore.data = idToken;
            });
            //DataStore.data = self.props.anUser;
        },1000*60);

        DataStore.listen(this.update);

    }



    doColorRows(row, index) {

        var rep = [];
        var nb = 0;
        if (index === 0) {    // <=> P1
            for (let pod in row) {
                if (pod !== 'priority') {
                    nb = parseInt(row[pod], 10);

                    if (nb !== 0) {
                        rep.push(<CustomTableCell key={row+pod+'redornot'} align="center" className="red-color">{row[pod]}</CustomTableCell>);
                    } else {
                        rep.push(<CustomTableCell key={row+pod+'redornot'} align="center">{row[pod]}</CustomTableCell>);
                    }
                }
            }
        } else if (index === 1) {   //<=> P2
            for (let pod in row) {
                if (pod !== 'priority') {
                    nb = parseInt(row[pod], 10);

                    /*   if (nb <= 2 && nb > 0) {
                           rep.push(<CustomTableCell key={row+pod+'orangeornot'} align="center" className="green-color">{row[pod]}</CustomTableCell>);

                       }*/
                    if (nb >= 10) {

                        rep.push(<CustomTableCell key={row+pod+'orangeornot'} align="center" className="orange-color">{row[pod]}</CustomTableCell>)
                    } else {

                        rep.push(<CustomTableCell key={row+pod+'orangeornot'} align="center">{row[pod]}</CustomTableCell>);
                    }
                }
            }
        } else {
            for(let pod in row) {
                if (pod !== 'priority') {
                    rep.push(<CustomTableCell key={row+pod+'nocolor'} align="center">{row[pod]}</CustomTableCell>);
                }
            }
        }

        return rep;
    }

//className={classes.root} pour Paper
    render(){
        const { classes } = this.props;

        return (
            <div>
                {
                    this.state && this.state.data &&
                    <div> {
                        <Paper className="table-issues" >
                            <Typography className="table-issues" variant="h5" gutterBottom style={{color: 'white'}}>Support - Pods</Typography>
                            <Table className="table-inside">
                                <TableHead className={classes.head}>
                                    <TableRow className={'EnTete'} key={'entete'}>
                                        <CustomTableCell>Priorities</CustomTableCell>
                                        <CustomTableCell align="center">Analytics</CustomTableCell>
                                        <CustomTableCell align="center">BusinessApps</CustomTableCell>
                                        <CustomTableCell align="center">CMS</CustomTableCell>
                                        <CustomTableCell align="center">Core</CustomTableCell>
                                        <CustomTableCell align="center">Search</CustomTableCell>
                                        <CustomTableCell align="center">Social</CustomTableCell>
                                        <CustomTableCell align="center">TOTAL</CustomTableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>

                                    {this.state.data.map((row, index) => (
                                        <TableRow className={classes.row} key={row+row.priority} >

                                            <CustomTableCell component="th" scope="row">{row.priority}</CustomTableCell>

                                            {this.doColorRows(row, index)}
                                            {index === 4 ?
                                                <CustomTableCell component="th" align="center" scope="row">{
                                                    this.state.data[0].Analytics+ this.state.data[1].Analytics+ this.state.data[2].Analytics+this.state.data[3].Analytics+
                                                    this.state.data[0].BusinessApps+ this.state.data[1].BusinessApps+ this.state.data[2].BusinessApps+this.state.data[3].BusinessApps+
                                                    this.state.data[0].CMS+ this.state.data[1].CMS+ this.state.data[2].CMS+this.state.data[3].CMS+
                                                    this.state.data[0].Core+ this.state.data[1].Core+ this.state.data[2].Core+this.state.data[3].Core+
                                                    this.state.data[0].Search+ this.state.data[1].Search+ this.state.data[2].Search+this.state.data[3].Search+
                                                    this.state.data[0].Social+ this.state.data[1].Social+ this.state.data[2].Social+this.state.data[3].Social
                                                }</CustomTableCell>

                                                :
                                                <CustomTableCell align="center">{(row.Analytics + row.BusinessApps + row.CMS + row.Core + row.Search + row.Social)}</CustomTableCell>

                                            }

                                        </TableRow>
                                    ))}

                                </TableBody>
                            </Table>
                        </Paper>
                    }</div>
                }
            </div>
        );
    }

}



export default withStyles(styles)(CustomizedTable);




// WEBPACK FOOTER //
// ./src/components/Tables/SupportTable.js